module.exports = __webpack_public_path__ + "img/loader-page.0c4641ee.svg";